module.exports = __webpack_public_path__ + "img/fa-duotone-900.ede63fc.svg";